(function () {
  'use strict';

  function text(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function isSizeName(name) {
    return text(name).includes('size');
  }

  function isCustomValue(value) {
    return text(value).includes('custom');
  }

  function getSelectedSizeValue(section) {
    // Huge theme button/radio variant picker.
    var groups = section.querySelectorAll('fieldset[data_options]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!isSizeName(group.getAttribute('data_options'))) continue;

      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value || '';

      // Huge theme also tracks the active swatch with a .selected label.
      var selectedLabel = group.querySelector('.option-swatch label.selected, label.selected');
      if (selectedLabel) {
        var forId = selectedLabel.getAttribute('for');
        if (forId) {
          var linkedInput = document.getElementById(forId);
          if (linkedInput) return linkedInput.value || '';
        }
        return selectedLabel.getAttribute('value') || selectedLabel.textContent || '';
      }
    }

    // Dropdown variant picker.
    var selects = section.querySelectorAll('select[name^="options["]');
    for (var j = 0; j < selects.length; j++) {
      var select = selects[j];
      if (isSizeName(select.getAttribute('name'))) return select.value || '';
    }

    // Fallback: selected variant title. Useful if a theme app changes the picker markup.
    var masterVariant = section.querySelector('.form__select_variant option:checked, select[id^="Variants-"] option:checked');
    if (masterVariant && isCustomValue(masterVariant.textContent)) return masterVariant.textContent || '';

    return '';
  }

  function updateCustomSizeState(section) {
    if (!section || section.getAttribute('data-ikapur-custom-size-enabled') !== 'true') return;

    var quote = section.querySelector('[data-custom-size-quote]');
    if (!quote) return;

    var sizeValue = getSelectedSizeValue(section);
    var isCustom = isCustomValue(sizeValue);

    var buyButtons = section.querySelector('.product_top_form .form__btns');
    var paymentTerms = section.querySelector('.product_top_form .shopify-payment-terms');

    if (buyButtons) buyButtons.style.display = isCustom ? 'none' : '';
    if (paymentTerms) paymentTerms.style.display = isCustom ? 'none' : '';

    quote.setAttribute('aria-hidden', isCustom ? 'false' : 'true');
    section.setAttribute('data-ikapur-custom-size-selected', isCustom ? 'true' : 'false');
    section.classList.toggle('ikapur-custom-size-selected', isCustom);
  }

  function queueUpdate(section) {
    window.requestAnimationFrame(function () {
      updateCustomSizeState(section);
      window.setTimeout(function () { updateCustomSizeState(section); }, 80);
      window.setTimeout(function () { updateCustomSizeState(section); }, 250);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ikapurCustomSizeInitialized === 'true') {
      if (section) queueUpdate(section);
      return;
    }
    section.dataset.ikapurCustomSizeInitialized = 'true';

    queueUpdate(section);

    section.addEventListener('change', function () {
      queueUpdate(section);
    }, true);

    section.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.option-swatch, variant-radios, variant-selects')) {
        queueUpdate(section);
      }
    }, true);

    // Huge changes the .selected class on swatch labels. Watch that state so the
    // quote remains reliable even if another theme script changes variants first.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          queueUpdate(section);
          break;
        }
      }
    });

    var picker = section.querySelector('variant-radios, variant-selects');
    if (picker) {
      observer.observe(picker, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'selected']
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[id^="ProductSection-"]')) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[id^="ProductSection-"]') : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  window.addEventListener('load', function () { initAll(document); });
  window.addEventListener('pageshow', function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
